import { defineFetch } from 'resift';

const makeGetRoleMembers = defineFetch({
  displayName: 'Get Role Members',
  make: (id: string) => ({
    request: (excluded?: boolean) => ({ http }) =>
      http({
        method: 'GET',
        route: `/roles/${id}/members`,
        query: {
          // "true" if adding to the exclusion list, "false" if adding to the inclusion list; if none passed, will return both manually excluded and included entities
          excluded,
        },
      }),
  }),
});

export default makeGetRoleMembers;
